import React, { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { SelectorIcon, CheckIcon } from "@heroicons/react/solid";

const CustomSelect = ({
    value,
    onChange,
    options = [],
    placeholder = "Select Option",
    disabled = false,
    error,
}) => {
    // Find the selected option object to display correct label
    const selectedOption = options.find((opt) => opt.value === value);

    return (
        <div className="w-full relative">
            <Listbox value={value} onChange={onChange} disabled={disabled}>
                <div className="relative mt-1">
                    <Listbox.Button
                        className={`relative w-full cursor-default rounded bg-white py-3 pl-4 pr-10 text-left border focus:outline-none focus:ring-2 focus:ring-color1 ${error ? "border-red-500" : "border-gray-300"
                            } ${disabled ? "bg-gray-100 cursor-not-allowed text-gray-500" : "text-gray-900"}`}
                    >
                        {selectedOption ? (
                            <div className="flex justify-between items-center w-full">
                                <span className="block truncate font-medium text-lg text-gray-900">
                                    {selectedOption.label}
                                </span>
                                {selectedOption.subLabel && (
                                    <div className="flex items-center gap-3 text-gray-500">
                                        <div className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center bg-gray-50">
                                            <span className="text-gray-400 text-sm">₹</span>
                                        </div>
                                        <span className="font-light text-xl text-gray-900">
                                            {selectedOption.subLabel}
                                        </span>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <span className="block truncate text-gray-400">{placeholder}</span>
                        )}
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <SelectorIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </span>
                    </Listbox.Button>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Listbox.Options className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {options.map((option, personIdx) => (
                                <Listbox.Option
                                    key={personIdx}
                                    className={({ active }) =>
                                        `relative cursor-default select-none py-3 pl-4 pr-10 ${active ? "bg-gray-100 text-gray-900" : "text-gray-900"
                                        }`
                                    }
                                    value={option.value}
                                >
                                    {({ selected }) => (
                                        <>
                                            <div className="flex justify-between items-center w-full">
                                                <span
                                                    className={`block truncate ${selected ? "font-medium" : "font-normal"
                                                        }`}
                                                >
                                                    {option.label}
                                                </span>
                                                {option.subLabel && (
                                                    <div className="flex items-center gap-2 text-gray-500 mr-6">
                                                        <div className="w-6 h-6 rounded-full border border-gray-300 flex items-center justify-center bg-gray-50">
                                                            <span className="text-gray-400 text-xs">₹</span>
                                                        </div>
                                                        <span
                                                            className={`font-light ${selected ? "font-medium" : ""
                                                                }`}
                                                        >
                                                            {option.subLabel}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            {selected ? (
                                                <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-color1">
                                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                </span>
                                            ) : null}
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
            {error && <p className="text-red-600 text-sm mt-1">{error.message}</p>}
        </div>
    );
};

export default CustomSelect;
